<template>
  <div v-if="images.length !== 0">
    <div class="pa-0">
      <ShootingTitleType :type="type" />
      <div class="img-row">
        <div class="img-row-block" v-for="(image, index) in images" :key="index">
          <ShootingGalleryItem :url="image.url" :index="index" @toggle-fullscreen="toggleFullscreen" />
          <div v-if="show === index">
            <ShootingGalleryItemFullscreen
              :url="image.url"
              :index="index"
              v-on:change-image="changeImage"
              @toggle-fullscreen="toggleFullscreen"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShootingGalleryItem from '@/components/shooting/ShootingGalleryItem.vue'
import ShootingGalleryItemFullscreen from '@/components/shooting/ShootingGalleryItemFullscreen.vue'
import ShootingTitleType from '@/components/shooting/ShootingTitleType.vue'

export default {
  name: 'ShootingGalleryByType',
  components: {
    ShootingGalleryItem,
    ShootingGalleryItemFullscreen,
    ShootingTitleType
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: null
    }
  },
  created() {
    this.eventKey = this.eventKeyCode.bind(this)
  },
  methods: {
    changeImage(value) {
      if (value === 'PREVIOUS' && this.show > 0) this.show = this.show - 1
      if (value === 'NEXT' && this.show < this.images.length - 1) this.show = this.show + 1
    },
    toggleFullscreen(e, index) {
      if (e) {
        this.show = index
        window.addEventListener('keydown', this.eventKey)
      } else {
        window.removeEventListener('keydown', this.eventKey)
        this.show = null
      }
    },
    eventKeyCode(ev) {
      if (ev.keyCode === 27) this.show = null
      if (ev.keyCode === 37 && this.show > 0) this.show = this.show - 1
      if (ev.keyCode === 39 && this.show < this.images.length - 1) this.show = this.show + 1
      if (this.show === null) window.removeEventListener('keydown', this.eventKey)
    }
  }
}
</script>

<style lang="sass" scoped>
.img-row
  display: flex
  flex-wrap: wrap
</style>
